import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lfwms-bp-orand-cell-editor',
  templateUrl: './orand-cell-editor.component.html',
  styleUrls: ['./orand-cell-editor.component.css']
})
export class OrAndCellEditorComponent implements ICellEditorAngularComp, OnDestroy {

  public params: any;
  public isLoading: boolean = true;
  public isDropup: boolean = false;
  public offset: number = 0;
  public templateId: number = 0;
  public cellValue: any = [];
  public cellDataRef: any = [];
  @ViewChild('primeFocus')
  private primeFocus;


  constructor() { }

  public agInit(params: any): void {
    this.params = params;
    this.params.eGridCell.addEventListener('focus', () => {
      this.primeFocus.nativeElement.focus();
      // this.primeFocus.nativeElement.select();
    });
  }

  public refresh(params: any): boolean {
    this.params = params;
    this.cellValue = this.params.value.cVal;
    return true;
  }

  public focusIn() {
    // Below change is done to avoid partial focus on multiple cells
    this.params.eGridCell.focus();
  }


  public getValue() {
    // return actually value json and not just cVal
    return this.params.value;
  }

  public setFocusedCell(row: any, property: any) {
    this.params.context.componentParent.searchService.getPagedData().focusedRow = row;
    this.params.context.componentParent.searchService.getPagedData().focusedCellId = property;
    this.params.context.componentParent.keyEventHandler.setFocusedCell(row, property);
  }

  public ngOnDestroy() {
  }

  public addLogicalOperation(operatorValue: string) {
    this.params.value.cVal = operatorValue;
    this.params.context.componentParent.searchService
      .getPagedData().pageRows[this.params.rowIndex].isEdited = true;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-editor/orand-cell-editor.component.ts